export const defaultFilters = {
  status: "true",
  deadline: "",
  developer: "",
  priceFrom: "",
  priceTo: "",
  areaFrom: "",
  areaTo: "",
  rooms: "",
  location: "",
  cityCategory: "",
  finishesMode: "",
  onlyApartments: false,
  onlyCommercial: false,
  showVehicles: false,
  excludePik: false,
  excludeGranel: false,
  showYandex: false,
};
